import {Pagination} from '../pagination.model';
import {Worker} from '../../../../workers/shared/model/worker.model';

export class WorkerPage extends Pagination {
  content: Worker[] = [];
}
